import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldString from "../../fields3/generic/string/string"
import FieldItemModelStoryPointsCalculated
    from "../../fields3/system/item-model/story-points-calculated/story-points-calculated";
import FieldItemModelTimeReportedCalculated
    from "../../fields3/system/item-model/time-reported-calculated/time-reported-calculated";
import FieldItemModelCalculatedExpenses from "../../fields3/system/item-model/calculated-expenses/calculated-expenses";
import FieldItemModelCalculatedEstimate from "../../fields3/system/item-model/calculated-estimate/calculated-estimate";
import FieldItemModelCalculatedSpentEstimate
    from "../../fields3/system/item-model/calculated-spent-estimate/calculated-spent-estimate";
import FieldItemModelCalculatedLaborCost from "../../fields3/system/item-model/calculated-labor-cost/calculated-labor-cost";
import FieldItemModelCalculatedServiceCost
    from "../../fields3/system/item-model/calculated-service-cost/calculated-service-cost";
import {ProjectDataField} from "../project/data-fields/@types"
import FieldConfig from "../../fields3/proto/field-config"

const baseConfig: FieldConfig[] = [
    {
        fieldId: 'calculatedStoryPoints',
        label: 'Story Points',
        type: FieldType.ITEM_MODEL_STORY_POINTS_CALCULATED
    },

    {
        fieldId     : 'calculatedTimeReports',
        label       : 'Time Reported',
        type        : FieldType.ITEM_MODEL_CALCULATED_TIME_REPORTS,
        dataFields  : [ProjectDataField.timeReports],
    },

    {
        fieldId     : 'calculatedExpenses',
        label       : 'Expenses',
        type        : FieldType.ITEM_MODEL_CALCULATED_EXPENSES,
        dataFields  : [ProjectDataField.expenses],
    },

    {
        fieldId: 'calculatedEstimated',
        label: 'Estimated',
        type: FieldType.ITEM_MODEL_CALCULATED_ESTIMATE
    },
    {
        fieldId     : 'calculatedSpentEstimated',
        label       : 'Spent / Estimated',
        type        : FieldType.ITEM_MODEL_CALCULATED_SPENT_ESTIMATE,
        dataFields  : [ProjectDataField.timeReports],
    },
    {
        fieldId     : 'calculatedLaborCost',
        label       : 'Labor cost',
        type        : FieldType.ITEM_MODEL_CALCULATED_LABOR_COST,
        dataFields  : [ProjectDataField.timeReports]
    },
    {
        fieldId     : 'calculatedServiceCost',
        label       : 'Service cost',
        type        : FieldType.ITEM_MODEL_CALCULATED_SERVICE_COST,
        dataFields  : [ProjectDataField.timeReports],
    },

]

export default class ItemModelFields extends FieldsCollection {

    // Quick access
    get calculatedStoryPoints()     : FieldItemModelStoryPointsCalculated { return this.get('calculatedStoryPoints') as FieldItemModelStoryPointsCalculated }
    get calculatedTimeReports()     : FieldItemModelTimeReportedCalculated { return this.get('calculatedTimeReports') as FieldItemModelTimeReportedCalculated }
    get calculatedExpenses()        : FieldItemModelCalculatedExpenses { return this.get('calculatedExpenses') as FieldItemModelCalculatedExpenses }
    get calculatedEstimated()       : FieldItemModelCalculatedEstimate { return this.get('calculatedEstimated') as FieldItemModelCalculatedEstimate }
    get calculatedSpentEstimated()  : FieldItemModelCalculatedSpentEstimate { return this.get('calculatedSpentEstimated') as FieldItemModelCalculatedSpentEstimate }

    get calculatedLaborCost()       : FieldItemModelCalculatedLaborCost { return this.get('calculatedLaborCost') as FieldItemModelCalculatedLaborCost }
    get calculatedServiceCost()     : FieldItemModelCalculatedServiceCost { return this.get('calculatedServiceCost') as FieldItemModelCalculatedServiceCost }

    constructor() {
        const fieldsConfig = baseConfig
        // we can modify base config with params in constructor if needed

        super(fieldsConfig, EntityType.ITEM_MODEL)
    }
}
